import { useCallback } from "react";
import {
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";
import type { Peer } from "@circle-react/types/Live/Peer";

export const useHMSPeerMediaStatus = (peer: Peer) => {
  const isMicrophoneEnabled = useHMSStore(selectIsPeerAudioEnabled(peer?.id));
  const isCameraEnabled = useHMSStore(selectIsPeerVideoEnabled(peer?.id));
  const hmsActions = useHMSActions();
  const muteMicrophone = useCallback(
    () =>
      peer?.audioTrack &&
      hmsActions.setRemoteTrackEnabled(peer.audioTrack, false),
    [hmsActions, peer?.audioTrack],
  );
  const disableCamera = useCallback(
    () =>
      peer?.videoTrack &&
      hmsActions.setRemoteTrackEnabled(peer.videoTrack, false),
    [hmsActions, peer?.videoTrack],
  );

  return {
    isMicrophoneEnabled,
    isCameraEnabled,
    muteMicrophone,
    disableCamera,
  };
};
